module.exports = __webpack_public_path__ + "img/icon_err.935291d3.svg";